export interface ColumnsWithLetter {
	Letter: string; // é¦å­æ¯
	Columns: string[];
}
export interface IDisplayColumn {
	Name: string;
	Hidden: boolean;
	Order: Order;
}
export enum Order {
	// OrderAsc ååº
	OrderAsc = '+',
	// OrderDesc éåº
	OrderDesc = '-',
	// OrderNone æ æåº
	OrderNone = ''
}
export interface IColumnType {
	Name: string;
	Type: string;
}
